export default "/images/sprite.symbol.svg?a52c0aed8947425c03b76fbd899ae3e7";